import { render, staticRenderFns } from "./WideCard.vue?vue&type=template&id=44e42d4c&"
import script from "./WideCard.vue?vue&type=script&lang=js&"
export * from "./WideCard.vue?vue&type=script&lang=js&"
import style0 from "./WideCard.vue?vue&type=style&index=0&id=44e42d4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports